import { mapState, mapGetters, mapMutations } from 'vuex';
import UAParser from 'ua-parser-js';
import { store } from '@/utils/common';
import { lessonStatus } from '@/utils/constants';

export default {
  data() {
    return {
      tourOptions: {
        useKeyboardNavigation: false,
        labels: null
      },
      tourCallbacks: {
        onFinish: this.endTour,
        onSkip: this.endTour
      },
      tourSteps: {
        ja: {
          deviceCheck: [
            {
              target: '.camera-selection',
              content: 'レッスンで使用するカメラを選択してください',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.mic-selection',
              content: 'レッスンで使用するマイクを選択してください',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.speaker-selection',
              content: '音声のテストを行えます',
              params: {
                placement: 'left',
                canSkip: true,
              }
            },
            {
              target: '.join_btn',
              content: 'MyStageに入室します',
              params: {
                placement: 'left'
              },
              before: () => (this.skipEndTour = true)
            }
          ],
          lesson: [
            {
              target: '.layout_btn',
              content: '画面のレイアウトを変更できます',
              params: {
                placement: 'bottom'
              }
            },
            {
              target: '.side-menu-btn',
              content: '設定のメニューを表示します',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.device-selection',
              content: 'カメラ・マイクの設定ができます',
              params: {
                placement: 'left'
              },
              before: () => this.setIsMenuVisible(true)
            },
            {
              target: '.virtual-bg',
              content: 'ご自身の背景をぼかすことができます',
              params: {
                placement: 'left',
                canSkip: true,
              }
            },
            {
              target: '.language-selection',
              content: '言語を選択できます',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.theme-selection',
              content: '画面の背景色を選ぶことができます',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.next-lesson',
              content: '次のLesson テキストを表示します',
              params: {
                placement: 'left'
              },
              before: () => this.showMaterialControls()
            },
            {
              target: '.previous-lesson',
              content: '一つ前のレッスンを表示します',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_in',
              content: 'テキストを拡大します',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_out',
              content: 'テキストを縮小します',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.phrases-dots',
              content: 'レッスン中にチャットに便利なフレーズを表示できます',
              params: {
                placement: 'top'
              },
              isStudent: true
            },
            {
              target: '.toolbar-dots',
              content: 'チャットのテキストの書式設定ができます',
              params: {
                placement: 'top'
              }
            }
          ],
          assessmentLesson: [
            {
              target: '.side-menu-btn',
              content: '設定のメニューを表示します',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.device-selection',
              content: 'カメラ・マイクの設定ができます',
              params: {
                placement: 'left'
              },
              before: () => this.setIsMenuVisible(true)
            },
            {
              target: '.virtual-bg',
              content: 'ご自身の背景をぼかすことができます',
              params: {
                placement: 'left',
                canSkip: true,
              }
            },
            {
              target: '.language-selection',
              content: '言語を選択できます',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.theme-selection',
              content: '画面の背景色を選ぶことができます',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_in',
              content: 'テキストを拡大します',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_out',
              content: 'テキストを縮小します',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.phrases-dots',
              content: 'レッスン中にチャットに便利なフレーズを表示できます',
              params: {
                placement: 'top'
              },
              isStudent: true
            },
            {
              target: '.toolbar-dots',
              content: 'チャットのテキストの書式設定ができます',
              params: {
                placement: 'top'
              }
            }
          ]
        },
        en: {
          deviceCheck: [
            {
              target: '.camera-selection',
              content: 'Select the camera for the lesson',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.mic-selection',
              content: 'Select the mic for the lesson',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.speaker-selection',
              content: 'You can test your speaker here',
              params: {
                placement: 'left',
                canSkip: true
              }
            },
            {
              target: '.join_btn',
              content: 'Enter MyStage from here',
              params: {
                placement: 'left'
              },
              before: () => (this.skipEndTour = true)
            }
          ],
          lesson: [
            {
              target: '.layout_btn',
              content: 'You can select the screen layout',
              params: {
                placement: 'bottom'
              }
            },
            {
              target: '.side-menu-btn',
              content: 'Display setting menu here',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.device-selection',
              content: 'You can set your camera and mic here',
              params: {
                placement: 'left'
              },
              before: () => this.setIsMenuVisible(true)
            },
            {
              target: '.virtual-bg',
              content: 'You can blur your background',
              params: {
                placement: 'left',
                canSkip: true,
              }
            },
            {
              target: '.language-selection',
              content: 'You can select language',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.theme-selection',
              content: 'You can select the background color',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.next-lesson',
              content: 'Go to the next lesson text',
              params: {
                placement: 'left'
              },
              before: () => this.showMaterialControls()
            },
            {
              target: '.previous-lesson',
              content: 'Go back to the previous lesson text',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_in',
              content: 'Zoom in your text',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_out',
              content: 'Zoom out your text',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.toolbar-dots',
              content: 'You can change setting of the chat text',
              params: {
                placement: 'top'
              }
            }
          ],
          assessmentLesson: [
            {
              target: '.side-menu-btn',
              content: 'Display setting menu here',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.device-selection',
              content: 'You can set your camera and mic here',
              params: {
                placement: 'left'
              },
              before: () => this.setIsMenuVisible(true)
            },
            {
              target: '.virtual-bg',
              content: 'You can blur your background',
              params: {
                placement: 'left',
                canSkip: true
              }
            },
            {
              target: '.language-selection',
              content: 'You can select language',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.theme-selection',
              content: 'You can select the background color',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_in',
              content: 'Zoom in your text',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.zoom_out',
              content: 'Zoom out your text',
              params: {
                placement: 'left'
              }
            },
            {
              target: '.toolbar-dots',
              content: 'You can change setting of the chat text',
              params: {
                placement: 'top'
              }
            }
          ]
        }
      },
      buttons: {
        ja: {
          buttonNext: '次へ',
          buttonPrevious: '戻る',
          buttonSkip: 'スキップ',
          buttonStop: '終了'
        },
        en: {
          buttonNext: 'Next',
          buttonPrevious: 'Previous',
          buttonSkip: 'Skip Tour',
          buttonStop: 'Finish'
        }
      },
      steps: null,
      tourName: null,
      skipEndTour: null,
    };
  },
  computed: {
    ...mapState(['isFirstLesson', 'isTest', 'lessonId', 'lessonStatus', 'isTrial']),
    ...mapState('layout', ['isMenuVisible']),
    ...mapGetters(['isStudent', 'displayLanguageSettings']),

    enableTour() {
      return (
        store.getShowTour(this.lessonId) && (
        (this.isStudent && this.isFirstLesson) ||
        (this.isStudent && this.isTrial)
        ) &&
        !this.isTest &&
        this.lessonStatus !== lessonStatus.finished
      );
    },
  },
  mounted() {
    const browser = new UAParser().getBrowser().name;
    let displayLanguageSettings = this.displayLanguageSettings;

    this.steps = this.steps.filter(function(step) {
      if (
        browser === 'Safari' ||
        (browser === 'Firefox' && step.target === '.speaker-selection')
      ) {
        return !step.params.canSkip;
      }

      if (step.target === '.language-selection' && !displayLanguageSettings) {
        return false;
      }

      return step;
    });

    this.tourOptions.labels = this.buttons[this.$i18n.locale];
  },
  methods: {
    ...mapMutations('layout', ['setIsMenuVisible']),
    ...mapMutations('material', ['setShowMaterialControl']),

    setupTour(name) {
      this.tourName = name;
      if (this.enableTour) {
        this.$tours[name].start();
      }
    },

    destroyTour() {
      if (this.enableTour) {
        this.$tours[this.tourName].start();
      }
    },

    endTour() {
      if (this.tourName === 'deviceSettingTour' && this.skipEndTour) {
        return;
      }

      store.setShowTour(this.lessonId, false);
      if (this.tourName === 'lessonPageTour') {
        if (this.isMenuVisible) {
          this.setIsMenuVisible(false);
        }
      }
    },

    showMaterialControls() {
      this.setShowMaterialControl(true);
    }
  }
};
